import { useMemo } from "react";

export default function AddressLabel({ address, addressOptions }) {
  const countryLabel = useMemo(() => {
    const country = addressOptions.countries.find(
      (c) => c.value === address.country
    );
    if (country) {
      return country.name;
    }
  }, [address, addressOptions]);

  return (
    <span>
      {address.recipient && address.recipient.trim() !== "" && (
        <>
          {address.recipient}
          <br />
        </>
      )}
      {address.line1}
      <br />
      {address.line2 && address.line2.trim() !== "" && (
        <>
          {address.line2}
          <br />
        </>
      )}
      {address.city} {address.state} {address.postalCode}
      <br />
      {countryLabel}
    </span>
  );
}
